<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/usa/sonoma')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country active" :to="localePath('/wine-guide/usa/sonoma/ridge-vineyards')">Ridge Vineyards</nuxt-link>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/usa/sonoma/sine-qua-non')">Sine Qua Non</nuxt-link>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/usa/sonoma/verite-vigneron')">Verite Vigneron</nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/usa/sonoma')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Ridge Vineyards</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Non c'è dubbio che il 21° secolo sia un gioco di sopravvivenza del più forte. In questa età
                        di geo-tagging, connessione costante e Wi-Fi illimitato, sembra che siano solo quelli con il
                        più grande budget di marketing che sono quelli che conosciamo. Per fortuna, ci sono alcune eccezioni al
                        regola. Con una tale pletora di meravigliose aziende vinicole in California, nessuno ti considererebbe un
                        ignoramus se alcuni dei vigneti più piccoli sono caduti fuori dal tuo radar (è per questo che siamo qui). Di
                        Certo, c'è il grande (Screaming Eagle), l'audace (Sine Qua Non) e il bello (Robert
                        Mondovi), ma per quanto riguarda il produttore che continua a produrre vini fantastici anno dopo anno
                        anno con poca pubblicità?
                    </div>

                    <div class="howto-title2">Una cassa di vino Cali-fomula</div>
                    <div class="howto-text">
                        Una ricca storia precede l'arrivo di Draper al timone di Ridge; originariamente piantato nel 1885 da a
                        medico in pensione di San Francisco, l'azienda vinicola californiana ha riscosso un modesto successo per gran parte del tempo
                        il XIX e l'inizio del XX secolo. Avanti veloce al 1959, quando la tenuta fu venduta a quattro
                        gli scienziati che hanno acquistato il vigneto isolato ad alta quota (1.300-2.700 piedi), hanno studiato il
                        terreno e piantato quello che sarebbe diventato il loro leggendario vino d'autore. Quell'anno è il Monte
                        Bello Cabernet era tra i migliori vini della California dell'epoca. Paul Draper si è unito a pochi anni
                        più tardi e il destino di Ridge Vineyard fu segnato.
                        <br><br>
                        Sostenendo i vigneti single blend, Draper ha criticato il vino sperimentale della tenuta
                        successo. Ridge è stata venduta a Otsuka Pharmaceutical Co., Ltd. nel 1986, anche se Draper rimane con
                        l'azienda e alla fine ha istituito tecniche di agricoltura sostenibile. Ridge Vineyards si è trasferita a
                        Tecniche di agricoltura biologica al 100% entro il 1999.
                    </div>

                    <div class="howto-title2">Ma che Bello</div>
                    <div class="howto-text">
                        Ridge Vineyards produce una vasta gamma di vini per tutte le tasche e tavolozze. La tenuta
                        produce quasi 100.000 casse all'anno, ma è ancora il loro Monte Bello che brilla
                        più luminoso. Forse uno dei pochi vini californiani che ha dimostrato di invecchiare, annate dal
                        Gli anni '60 e '70 sono molto popolari tra i collezionisti (e molto scarsi).
                        <br><br>
                        Tuttavia, se stai davvero cercando un'aggiunta idiosincratica al tuo portafoglio, il 1971
                        Eisele è stato prodotto solo una volta ed è raro come i denti di gallina. L'ultimo avvistamento di una bottiglia a
                        l'azione è stata nel 2014 e venduta per oltre $ 1.000.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Ridge Vineyards</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Es besteht kaum ein Zweifel daran, dass das 21. Jahrhundert ein Überlebensspiel des Stärksten ist. In diesem Alter
                        Von Geo-Tagging, ständiger Verbindung und unbegrenztem WLAN scheinen es nur diejenigen zu sein, die über das verfügen
                        Das größte Marketingbudget kennen wir. Zum Glück gibt es einige Ausnahmen
                        Regel. Bei solch einer Fülle an wunderbaren Weingütern in Kalifornien würde Sie niemand als einen bezeichnen
                        Ignorant, wenn einige der kleineren Weinberge von Ihrem Radar verschwunden sind (dafür sind wir hier). Von
                        Natürlich gibt es das Große (Screaming Eagle), das Kühne (Sine Qua Non) und das Schöne (Robert
                        Mondovi), aber was ist mit dem Produzenten, der Jahr für Jahr fantastischen Wein herstellt?
                        Jahr mit wenig Werbung?
                    </div>

                    <div class="howto-title2">Eine Kiste Cali-Formula-Wein</div>
                    <div class="howto-text">
                        Eine reiche Geschichte geht Drapers Ankunft an Ridges Spitze voraus; ursprünglich 1885 von a gepflanzt
                        Als pensionierter Arzt aus San Francisco hatte das kalifornische Weingut über weite Strecken bescheidenen Erfolg
                        das 19. und frühe 20. Jahrhundert. Spulen wir vor ins Jahr 1959, als das Anwesen an vier Personen verkauft wurde
                        Wissenschaftler, die den hochgelegenen (1.300-2.700 Fuß) isolierten Weinberg kauften, untersuchten die
                        Erde und pflanzte das an, was später zu ihrem legendären, charakteristischen Wein werden sollte. Die diesjährige Monte
                        Bello Cabernet gehörte zu den besten Weinen Kaliforniens dieser Zeit. Paul Draper kam ein paar Jahre dazu
                        später war das Schicksal von Ridge Vineyard besiegelt.
                        <br><br>
                        Draper, der sich für Single-Blend-Weinberge einsetzt, brachte den Experimentalwein des Weinguts auf den Prüfstand
                        Erfolg. Ridge wurde 1986 an Otsuka Pharmaceutical Co., Ltd. verkauft, Draper bleibt jedoch dabei
                        das Unternehmen und führte schließlich nachhaltige Anbautechniken ein. Ridge Vineyards ist umgezogen
                        100 % biologischer Anbau bis 1999.
                    </div>

                    <div class="howto-title2">Ma che Bello</div>
                    <div class="howto-text">
                        Ridge Vineyards produziert eine große Auswahl an Weinen für jeden Geldbeutel und jeden Gaumen. Das Anwesen
                        produziert jährlich fast 100.000 Kisten, aber es ist immer noch ihr Monte Bello, der glänzt
                        am hellsten. Vielleicht einer der wenigen kalifornischen Weine, der nachweislich altert, Jahrgänge aus dem
                        1960er und 1970er Jahre sind bei Sammlern sehr beliebt (und sehr selten).
                        <br><br>
                        Wenn Sie jedoch wirklich auf der Suche nach einer eigenwilligen Ergänzung Ihres Portfolios sind, ist die 1971 genau das Richtige für Sie
                        Eisele wurde nur einmal hergestellt und ist so selten wie Hühnerzähne. Die letzte Sichtung einer Flasche bei
                        Die Aktion fand im Jahr 2014 statt und wurde für über 1.000 US-Dollar verkauft.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Vignobles Ridge</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Il ne fait aucun doute que le 21ème siècle est un jeu de survie du plus fort. A cet âge
                        de géolocalisation, de connexion constante et de Wi-Fi illimité, il semble que ce ne soient que ceux qui ont le
                        plus gros budget marketing qui sont ceux que nous connaissons. Heureusement, il existe quelques exceptions à la
                        règle. Avec une telle pléthore de merveilleux vignobles en Californie, personne ne vous considérerait comme un
                        ignorez si certains des plus petits vignobles sont tombés de votre radar (c'est pour cela que nous sommes ici). De
                        bien sûr, il y a du grand, (Screaming Eagle), du hardi (Sine Qua Non) et du beau (Robert
                        Mondovi), mais qu'en est-il du producteur qui continue à faire du vin fantastique année après
                        année avec peu de publicité?
                    </div>

                    <div class="howto-title2">Une caisse de vin Cali-fomula</div>
                    <div class="howto-text">
                        Une riche histoire précède l'arrivée de Draper à la barre de Ridge; initialement planté en 1885 par un
                        médecin retraité de San Franciscain, la cave californienne a connu un succès modeste pendant une grande partie de
                        le 19e et le début du 20e siècle. Avance rapide jusqu'en 1959, lorsque le domaine a été vendu à quatre
                        les scientifiques qui ont acheté la haute altitude (1 300-2 700 pieds), vignoble isolé, ont étudié la
                        sol et ont planté ce qui allait devenir leur vin légendaire et signature. Cette année-là Monte
                        Bello Cabernet était parmi les meilleurs vins de Californie de l'époque. Paul Draper rejoint quelques années
                        plus tard et le destin de Ridge Vineyard était scellé.
                        <br><br>
                        Champion des vignobles à assemblage unique, Draper a porté le vin expérimental du domaine à un niveau critique
                        succès. Ridge a été vendu à Otsuka Pharmaceutical Co., Ltd. en 1986, bien que Draper reste avec
                        l'entreprise et a finalement institué des techniques agricoles durables. Ridge Vineyards est passé à
                        Techniques d'agriculture 100% biologique d'ici 1999.
                    </div>

                    <div class="howto-title2">Ma che Bello</div>
                    <div class="howto-text">
                        Ridge Vineyards produit une vaste gamme de vins pour toutes les poches et toutes les palettes. Le domaine
                        produit près de 100 000 caisses annuellement, mais c'est toujours leur Monte Bello qui brille
                        le plus brillant. Peut-être l'un des seuls vins californiens à avoir vieilli, des millésimes du
                        Les années 1960 et 1970 sont très appréciées des collectionneurs (et très rares).
                        <br><br>
                        Cependant, si vous recherchez vraiment un ajout idiosyncrasique à votre portefeuille, le 1971
                        Eisele n'a été produit qu'une seule fois et est aussi rare que les dents de poule. La dernière observation d'une bouteille à
                        action était en 2014 et vendu pour plus de 1 000 $.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Ridge Vineyards</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        There is little doubt that the 21-st century is a game of survival of the fittest. In this age
                        of geo-tagging, constant connection and unlimited Wi-Fi, it seems like it is only those with the
                        biggest marketing budget that are the ones we know. Thankfully, there are some exceptions to the
                        rule. With such a plethora of wonderful wineries in California, no one would consider you an
                        ignoramus if some of the smaller vineyards fell off your radar (that’s what we’re here for). Of
                        course, there is the big, (Screaming Eagle), the bold (Sine Qua Non) and the beautiful (Robert
                        Mondovi), but what about the producer who just gets on with making fantastic wine year after
                        year with little publicity?
                    </div>

                    <div class="howto-title2">A case of Cali-fomula wine</div>
                    <div class="howto-text">
                        A rich history precedes Draper’s arrival at Ridge’s helm; originally planted in 1885 by a
                        retired San Franciscan doctor, the Californian winery enjoyed modest success throughout much of
                        the 19th and early 20th-century. Fast-forward to 1959, when the estate was sold to four
                        scientists who purchased the high altitude (1,300-2,700 feet), isolated vineyard, studied the
                        soil and planted what would go on to become their legendary, signature wine. That year’s Monte
                        Bello Cabernet was among California’s finest wines of the era. Paul Draper joined a few years
                        later and Ridge Vineyard’s fate was sealed.
                        <br><br>
                        Championing single blend vineyards, Draper took the estate’s experiment wine to critical
                        success. Ridge was sold to Otsuka Pharmaceutical Co., Ltd. in 1986, although Draper remains with
                        the company and eventually instituted sustainable farming techniques. Ridge Vineyards shifted to
                        100% organic farming techniques by 1999.
                    </div>

                    <div class="howto-title2">Ma che Bello</div>
                    <div class="howto-text">
                        Ridge Vineyards produce a huge spectrum of wine for all pockets and palettes. The estate
                        produces close to 100,000 cases annually, but it is still their Monte Bello that shines
                        brightest. Perhaps one of the only Californian wines that has proven to age, vintages from the
                        1960s and 1970s are very popular among collectors (and very scarce).
                        <br><br>
                        However, if you are really looking for an idiosyncratic addition to your portfolio, the 1971
                        Eisele was only produced once and is as rare as hen’s teeth. The last sighting of a bottle at
                        action was in 2014 and sold for over $1,000.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "RidgeVineyards",
    head: {
        title: 'Ridge Vineyards | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the rich and flavorful wines from Ridge Vineyards, a leading wine producer in the prestigious Sonoma wine region. Experience the perfect blend of traditional winemaking techniques and innovative approaches in every bottle. Savor the unique character and quality of Ridge Vineyards wines today.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    },
    data() {
        return {
            select: {report: 'Ridge Vineyards', src: '/wine-guide/usa/sonoma/ridge-vineyards'},
            items: [
                { report: 'Ridge Vineyards', src: '/wine-guide/usa/sonoma/ridge-vineyards' },
                { report: 'Sine Qua Non', src: '/wine-guide/usa/sonoma/sine-qua-non' },
                { report: 'Verite Vigneron', src: '/wine-guide/usa/sonoma/verite-vigneron' }
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}

.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
